import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { baseApiService } from "../../../services/api/axios-config/axios-config";
import { SelectField } from "../../ui";

interface ProfitMarginBudgetConfig {
  id: string;
  name: string;
  value: string;
}

interface SelectProfitMarginBudgetConfigProps {
  name: string;
  methods: any;
  disabled?: boolean;
  required?: boolean;
  label?: string;
}

export function SelectProfitMarginBudgetConfig({
  name,
  methods,
  disabled = false,
  required = false,
  label = "Selecione a Margem de Lucro",
}: SelectProfitMarginBudgetConfigProps) {
  const [configs, setConfigs] = useState<ProfitMarginBudgetConfig[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await baseApiService.get("company/select-company-profit-margin-budget");
      setConfigs(data.data.data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    localStorage.setItem("profitMarginBudgetConfigs", JSON.stringify(configs));
  }, [configs]);

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field }) => (
        <SelectField
          label={label}
          value={typeof field.value === 'object' ? field.value.id : field.value || ""}
          onChange={(e) => {
            field.onChange(e.target.value);
          }}
          required={required}
          disabled={disabled}
        >
          <option value="" />
          {configs.map((config) => (
            <option key={config.id} value={config.id}>
              {`${config.name} - ${config.value}%`}
            </option>
          ))}
        </SelectField>
      )}
    />
  );
}
